<div class="modal-content modal-milvus" style="zoom: 0.85;">
    <div class="modal-header-milvus align-items-center">
        <div class="col-6 header-col" style="margin-top: -10px; margin-left: -6px;">
            <span class="modal-title" id="modal-title-default">{{'HISTORICO_USO_BASE_IA' | translate}}</span>
        </div>
        <div class="col-6 header-col" style="margin-top: -10px;">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                <i class="mdi mdi-close"></i>
            </button>
        </div>
    </div>

    <div class="modal-body divider-top">
        <div class="historico-scroll">
            <div *ngFor="let item of lista" class="historico-card">
                <div class="historico-section">
                    <strong class="historico-label">{{'PERGUNTA_DO_CLIENTE' | translate}}</strong>
                    <div class="historico-content">{{item.mensagem_usuario}}</div>
                </div>

                <div class="historico-section">
                    <strong class="historico-label">{{'PROMPT_UTILIZADO' | translate}}</strong>
                    <div class="historico-content">{{item.mensagem_sistema}}</div>
                </div>

                <div *ngIf="item.pergunta_completa" class="historico-section">
                    <strong class="historico-label">{{'PROMPT_COMPLETO' | translate}}</strong>
                    <div class="historico-content">{{formatarSemQuebraLinha(item.pergunta_completa)}}</div>
                </div>

                <div class="historico-section">
                    <strong class="historico-label">{{'BASE_CONHECIMENTO_UTILIZADA' | translate}}</strong>
                    <ol *ngIf="item.base_conhecimento?.length; else semBaseConhecimento" class="historico-base-conhecimento">
                        <li *ngFor="let bc of item.base_conhecimento">
                            {{bc.nome}}
                            <div class="historico-base-id">ID: {{bc.id}}</div>
                        </li>
                    </ol>
                    <ng-template #semBaseConhecimento>
                        <div class="historico-content">{{'NAO_POSSUI' | translate}}</div>
                    </ng-template>
                </div>

                <div *ngIf="item.base_conhecimento?.length" class="historico-section">
                    <strong class="historico-label">{{'TEXTO_SELECIONADO_BASE_CONHECIMENTO' | translate}}</strong>
                    <ul class="historico-base-conhecimento">
                        <li *ngFor="let bc of item.base_conhecimento">
                            <div >{{getBaseConhecimentoTitulo(bc)}}</div>
                            <ol *ngIf="getChunks(bc) as chunks" class="historico-chunks">
                                <li *ngFor="let chunk of chunks">
                                    <div class="historico-content">{{chunk.chunk_texto}}</div>
                                </li>
                                <li *ngIf="!chunks.length">
                                    <div class="historico-content">{{'TODO_ARTIGO_FOI_SELECIONADO' | translate}}</div>
                                </li>
                            </ol>
                        </li>
                    </ul>
                </div>

                <div class="historico-section">
                    <strong class="historico-label">{{'RESPOSTA_DA_IA' | translate}}</strong>
                    <div class="historico-content">{{item.resposta}}</div>
                </div>
            </div>
        </div>
    </div>
</div>
